import React, { useEffect } from 'react';
import { useResolvedPath, useMatch, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import { TransactionsContainer } from './components/transactions.container';
import { ChatPageContainer } from './components/chat-page.container';
import { ApplicationDetailsContainer } from './components/application-details.container';
import { ActivityLogContainer } from './components/activity-log.container';
import { FilesContainer } from './components/files.container';
import { PageLayoutProps } from '../../../../shared/menu-component';
import { CaseHistoryContainer } from './components/case-history.container';
import { CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragment } from '../../../../../generated';
import { ActiveCaseSummary } from './pages/active-summary';

interface IdentityVerificationProps {
  staffUserData: CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragment;
  isApplicantSection?: boolean;
}

export const IdentityVerification: React.FC<IdentityVerificationProps> = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const chatRoutePath = useResolvedPath('chat');
  const applicationRoutePath = useResolvedPath('application');
  const filesRoutePath = useResolvedPath('files');
  const transactionsRoutePath = useResolvedPath('transactions');
  const activityLogRoutePath = useResolvedPath('activity-log');
  const caseHistoryRoutePath = useResolvedPath('case-history');

  const pathFromUrl: string = window.location.pathname.split('/')[2];
  const isCaseOrApplicant: string = pathFromUrl == 'cases' ? 'Cases' : 'Applicants';

  // redirect to (default) Chat if a case is selected
  const rootRoutePath = useResolvedPath('');
  const match = useMatch(rootRoutePath.pathname);
  useEffect(() => {
    if (match) {
      navigate('chat');
    }
  }, [match]);

  const pageLayouts: PageLayoutProps[] = [
    {
      path: chatRoutePath.pathname,
      title: 'Applicant Messages',
      icon: <></>,
      id: 'ROOT'
    },
    {
      path: applicationRoutePath.pathname,
      title: 'Application',
      icon: <></>,
      id: 'application',
      parent: 'ROOT'
    },
    {
      path: filesRoutePath.pathname,
      title: 'Files',
      icon: <></>,
      id: 'files',
      parent: 'ROOT'
    },
    {
      path: transactionsRoutePath.pathname,
      title: 'Transactions',
      icon: <></>,
      id: 'transactions',
      parent: 'ROOT'
    },
    {
      path: activityLogRoutePath.pathname,
      title: 'Activity Log',
      icon: <></>,
      id: 'activity-log',
      parent: 'ROOT'
    },
    ...(props?.staffUserData?.role?.permissions?.idCasePermissions?.canViewCaseHistory
      ? [{
          path: caseHistoryRoutePath.pathname,
          title: 'Case History',
          icon: <></>,
          id: 'case-history',
          parent: 'ROOT'
        }]
      : [])
  ];

  return (
    <div>
      <Routes>
        <Route path="" element={<ActiveCaseSummary pageLayouts={pageLayouts} isApplicantSection={props.isApplicantSection}/>}>
          <Route path="chat" element={<ChatPageContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="application" element={<ApplicationDetailsContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="files" element={<FilesContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="transactions" element={<TransactionsContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          <Route path="activity-log" element={<ActivityLogContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant} />} />
          {props?.staffUserData?.role?.permissions?.idCasePermissions?.canViewCaseHistory && <Route path="case-history" element={<CaseHistoryContainer caseId={params['caseId'] ?? ''} isCaseOrApplicant={isCaseOrApplicant}/>} />}
        </Route>
      </Routes>
    </div>
  );
};
